import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';

const StyledSwitch = styled((props: SwitchProps) => (
    <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 40,
    height: 24,
    padding: '0px',
    '& .MuiSwitch-switchBase': {
        left: '4px',
        top: '4px',
        padding: 0,
        transitionDuration: '300ms',
        '&.Mui-checked:not(.Mui-disabled)': {
            transform: 'translateX(16px)',
            color: 'var(--lm-accent-contrast)',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: 'var(--lm-accent)',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: 'var(--lm-accent-ink)',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
        border: '1px solid',
        borderColor: theme.palette.primary.main,
        boxShadow: 'none',
    },
    '& .MuiSwitch-track': {
        borderRadius: 16,
        backgroundColor: 'var(--lm-border)',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

export default StyledSwitch;
